<template>
    <v-container fluid>   
      <LeftMenu/> 
        <v-layout row wrap>   
          <v-flex xs12>
            <Progress :show="this.showProgress" />
          </v-flex>
          <v-flex xs1></v-flex>
          <v-flex xs11>
            <v-data-table
              :headers="headers"
              :items="incomesFormatted"
              :items-per-page="50"
              item-key="id"
              sort-by="incomeDate"
              :sort-desc=true
              class="elevation-1"
              :search="search"
              :custom-filter="filterOnlyCapsText"
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Incomes</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-flex xs2 class="pr-3">
                    <DatePicker picker-label="" :date-value="incomesStartDate" @dateSelected="incomesStartDate=$event" />
                  </v-flex>
                  <v-flex xs2 class="pr-3"> 
                    <DatePicker picker-label="" :date-value="incomesEndDate" @dateSelected="incomesEndDate=$event" />                  
                  </v-flex> 
                   <v-flex xs5>
                    <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="900px">
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark class="mb-2" v-on="on">New Income</v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>                                                                                                                                           
                            <v-flex xs12 sm6 md4>                              
                              <DatePicker picker-label="Income Date" :date-value="editedItem.incomeDate" @dateSelected="editedItem.incomeDate=$event" /> 
                            </v-flex>   
                            <v-flex xs12 sm6 md8>
                              <v-combobox
                                :items="bankAccountList"
                                label="Select Bank Account"
                                v-model="editedItem.bankAccount"
                                item-text="accountName"
                                single-line
                                return-object
                                v-on:change="bankAccountSelected"
                              ></v-combobox>
                            </v-flex>                                                                               
                            <v-flex xs12 sm6 md4>
                              <v-currency-field :key="editedItem.id" v-model="editedItem.amount" label="Amount"></v-currency-field>
                            </v-flex>                         
                                                           
                            <v-flex xs12 sm6 md4>
                              <v-combobox
                                disabled
                                :items="currencyListWithText"
                                label="Select Currency"
                                v-model="editedItem.currency"
                                item-text="text"
                                single-line
                                return-object
                              ></v-combobox>
                            </v-flex>        
                            <v-flex xs12 sm6 md4/>                                                    
                             <v-flex xs12 sm6 md3>
                              <v-combobox
                                :items="masterCategoryList"
                                label="Select Master Category"
                                v-model="selectedMasterCategory"
                                item-text=""
                                single-line
                                return-object
                                v-on:change="getCategoriesByMaster"
                              ></v-combobox>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                              <v-combobox
                                :items="categoryList"
                                label="Select Category"
                                v-model="editedItem.category"
                                item-text="text"
                                single-line
                                return-object
                              ></v-combobox>
                            </v-flex>   
                            <v-flex xs12 sm6 md6 
                              v-if="editedItem.category.personnelRelated"  >                             
                               <v-combobox                                
                                :items="personnels"
                                label="Select Personnel"
                                v-model="editedItem.personnel"
                                item-text="name"
                                single-line
                                return-object
                              >
                                <template slot="selection" slot-scope="data">
                                  {{ data.item.name }}  {{ data.item.surname }}
                                </template>
                                <template slot="item" slot-scope="data">
                                  {{ data.item.name }}  {{ data.item.surname }}
                                </template>
                              </v-combobox>
                            </v-flex> 
                            <v-flex xs12 sm6 md6
                              v-if="editedItem.category.saleRelated" >
                              <v-combobox                                                               
                                :items="saleList"
                                label="Select Sale"
                                v-model="editedItem.sale"
                                item-text="saleText"
                                single-line                                
                                return-object
                              ></v-combobox>
                            </v-flex> 
                            <v-flex xs12 sm6 md12>
                              <v-combobox
                                :items="bonusTypeList"
                                label="Select Bonus Types"
                                v-model="editedItem.bonusTypes"
                                item-text="name"
                                multiple
                                chips
                                return-object
                              ></v-combobox>
                            </v-flex> 
                            <v-flex xs12 sm6 md12>
                              <v-textarea v-model="editedItem.explanation"  :outlined="true"
                              :auto-grow="true" :clearable="true"
                              label="Explanation"></v-textarea>
                            </v-flex>                                                                                                                                                                       
                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="close">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
                <v-layout row wrap>
                  <v-flex xs1/>  
                  <v-flex xs1 align-self-center="true">  
                    <Xlsx filename="incomes" :items="xlsxItems"  :headers="xlsxHeaders" />                                      
                  </v-flex>   
                  <v-flex xs1 align-self-center="true">
                  Total:  
                  </v-flex>
                  <v-flex xs2 align-self-center="true">
                    {{ totalIncomeUSDAmountFormatted}} USD                   
                  </v-flex>  
                  <v-flex xs1 align-self-center="true">
                  Total:  
                  </v-flex>
                  <v-flex xs2 align-self-center="true">
                    {{ totalIncomeAmountFormatted}} TRY                   
                  </v-flex>                     
                  <v-flex xs2 align-self-baseline="center">
                    <v-combobox
                      :items="filterBonusTypeList"
                      label="Filter By Bonus Type"
                      v-model="selectedBonusTypesFilter"
                      item-text="name"
                      multiple
                      chips
                      return-object
                    ></v-combobox> 
                  </v-flex>
                  <v-flex xs1 align-self-baseline="center">
                    <v-icon                  
                      @click="filterIncomes">
                      mdi-refresh
                    </v-icon>
                  </v-flex> 
                </v-layout>   
              </template> 
              <template v-slot:body.append>                    
              </template>     
              <template v-slot:item.getIncomeResource="{ item }">                 
                {{item.sale? 'Sale '+item.sale.id : ''}}         
              </template>          
              <template v-slot:item.incomesActions="{ item }">   
                <v-icon                  
                  @click="duplicateItem(item)">
                  mdi-content-duplicate
                </v-icon>           
                <v-icon                  
                  @click="editItem(item)">
                  mdi-table-edit
                </v-icon>
                <v-icon                  
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
    </v-container>
</template>


<script>
import LeftMenu from '../components/LeftMenu';
import DatePicker from '../components/DatePicker';
import Progress from '../components/Progress';
import Xlsx from '../components/Xlsx';
import formatPrice from '../helpers/formatter';
import formatToDouble from '../helpers/formatToDouble';
import getTwoYearsBeforeStart from '../helpers/getTwoYearsBeforeStart';
import getCurrentDate from '../helpers/getCurrentDate';
import getCurrentMonthStart from '../helpers/getCurrentMonthStart';

const API_URL = 'incomes';
const CURRENCIES_API_URL = 'definitions/currencies';
const BANK_ACCOUNTS_API_URL = 'definitions/bankAccounts';
const CATEGORIES_API_URL = 'definitions/incomeCategories/masterCategory';
const MASTER_CATEGORIES_API_URL = 'definitions/incomeCategories/masterCategories';
const SALES_API_URL = 'sales'
const BONUS_TYPES_API_URL = 'definitions/bonusTypes';
const PERSONNEL_API_URL = 'definitions/personnelReduced';
export default {
    components:{
      LeftMenu,
      DatePicker,
      Progress,
      Xlsx
    },
    data () {
    return {
      dialog: false,
      search: '',
      showProgress : false,
      selectedBonusTypesFilter: [],
      incomesStartDate: '',
      incomesEndDate: '',
      salesStartDate: '',
      salesEndDate: '',
      totalIncomeAmount: 0,
      totalIncomeAmountUSD: 0,
      categoryList: [],
      saleList: [],
      bonusTypeList: [],
      bankAccountList: [],
      masterCategoryList: [],
      personnels: [],
      selectedMasterCategory: '',
      currencyList: [],
      incomes: [],
      editedIndex: -1,
      editedItem: {
        category: '',
        amount: 0,
      },
      defaultItem: {
        category: '',
        amount: 0, 
      },
      xlsxHeaders: {
        id : 'Income Id' ,
        incomeDate : 'Income Date' ,
        category : 'Category'  ,
        explanation : 'Explanation' ,       
        amount : 'Amount' ,        
        currency : 'Currency',
        account : 'Account' 
      }
    }
  },
  computed: {
    headers () {
      return [
        { text: 'Income Id',align: 'left',sortable: true,value: 'id'},
        { text: 'Income Date', value: 'incomeDate' },
        { text: 'Resource', value: 'getIncomeResource' },
        { text: 'Category',  value: 'category.text'  },
        { text: 'Explanation',align: 'left',sortable: true,value: 'explanation'},        
        { text: 'Amount',  align: 'right', value: 'amountFormatted'  , sort: (a, b) =>  formatToDouble(a) - formatToDouble(b) },       
        { text: 'Currency', value: 'currency.code' },
        { text: 'Account', value: 'bankAccount.accountName' },
        { text: 'Actions', value: 'incomesActions', sortable: false },
      ]
    },
    xlsxItems(){
      return this.incomes.map((item) => {
        return {
          id: item.id,
          incomeDate: item.incomeDate,
          category: item.category.text,
          explanation: item.explanation,
          amount: formatPrice(item.amount) ,
          currency: item.currency.code,
          account: item.bankAccount.accountName                 
        }
      });
    },    
    filterBonusTypeList(){
      let newList = this.bonusTypeList;
      newList.push({id:0,name:""});
      return newList;
    },
    totalIncomeUSDAmountFormatted(){
      return formatPrice(this.totalIncomeAmountUSD);
    },
    totalIncomeAmountFormatted(){
      return formatPrice(this.totalIncomeAmount);
    },
    incomesFormatted(){
      return this.incomes.map((item) => {
        item.amountFormatted = formatPrice(item.amount);
        return item;  
      })
    },
    currencyListWithText(){
      return this.currencyList.map((item) => {
        return {
          id: item.id,
          code: item.code,
          text: item.code+' - '+item.text          
        };
      })
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New Income' : 'Edit Income'
    },
  },
  created() {    
    this.showProgress = true;
    this.fillIntervalDates();
    this.salesStartDate = getTwoYearsBeforeStart();
    this.salesEndDate = getCurrentDate();
    this.getMasterCategories();    
    this.getBonusTypes();
    this.getCurrencies();
    this.getBankAccounts();
    this.getPersonnels();
    this.getSalesByInterval(this.salesStartDate, this.salesEndDate);
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    incomesStartDate (val){
      this.incomesStartDate = val;
      if(val && this.incomesEndDate){        
        this.getIncomesByInterval(this.incomesStartDate,this.incomesEndDate);
      }
    },
    incomesEndDate(val){
      this.incomesEndDate = val;
      if(val && this.incomesStartDate){      
        this.getIncomesByInterval(this.incomesStartDate,this.incomesEndDate);
      }
    },
  },
  methods: {
    filterIncomes (){
      this.showProgress = true;
      var selectedFilters = [];
      if(this.selectedBonusTypesFilter && this.incomesStartDate && this.incomesEndDate){         
        selectedFilters = Array.from(this.selectedBonusTypesFilter, x => x.id);
        this.getIncomesByIntervalAndBonusType(this.incomesStartDate,this.incomesEndDate,selectedFilters);
      }
    },
    async fillIntervalDates(){
      await this.setEndDate();
      this.incomesStartDate = getCurrentMonthStart();
    },
    async setEndDate(){
      this.incomesEndDate = getCurrentDate();
    },
    editItem (item) {      
      this.selectedMasterCategory = item.category.masterCategory;
      this.editedIndex = this.incomes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    async duplicateItem (item) {      
      this.selectedMasterCategory = item.category.masterCategory;
      this.editedItem = Object.assign({}, item)
      this.editedIndex = -1; 

      var selectedFilters = [];  
      selectedFilters.push(item.category);
      selectedFilters = Array.from(selectedFilters, x => x.code); 
      this.dialog = true
    },
    deleteItem (item) {
      if(confirm('Are you sure you want to delete this item?')){
        this.deleteIncome(item);
      } 
    },

    close () {
      this.selectedMasterCategory = '';
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {

      if(!this.editedItem.incomeDate){
        alert('Income Date cannot be empty!');
        return;
      }      
      if(!this.editedItem.bankAccount){
        alert('Bank Account cannot be empty!');
        return;
      } 
      if(!this.editedItem.category){
        alert('Category cannot be empty!');
        return;
      }     
      if(!this.editedItem.amount){
        alert('Amount cannot be empty!');
        return;
      }   
      if(!this.editedItem.currency){
        alert('Currency cannot be empty!');
        return;
      } 

      if (this.editedIndex > -1) {        
        this.updateIncome(this.editedItem);
      } else {
        this.addIncome(this.editedItem);         
      }      
    },
    addIncome(item){
      this.showProgress = true;
      this.$axios.post(this.$apiurl + API_URL, {
        currencyId: item.currency.id,
        bankAccountId: item.bankAccount.id,
        saleId: item.sale ? item.sale.id : null,
        categoryId: item.category.id,
        amount: item.amount,
        incomeDate:item.incomeDate,
        explanation: item.explanation,
        personnelId: item.personnel ? item.personnel.id : null,
        bonusTypes : item.bonusTypes ? Array.from(item.bonusTypes,x => x.id) : null
      })
      .then(response => {        
        if (response.status === 201) {
          this.getIncomesByInterval(this.incomesStartDate,this.incomesEndDate);
          this.$radio.$emit('success', {message:'Income Created Successfully'});
          this.close();
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    updateIncome(item){
      this.showProgress = true;
      let that = this;
      this.$axios.put(this.$apiurl + API_URL, {
        id: item.id,
        currencyId: item.currency.id,
        bankAccountId: item.bankAccount.id,
        saleId: item.sale ? item.sale.id : null,
        categoryId: item.category.id,
        amount: item.amount,
        incomeDate:item.incomeDate,
        explanation: item.explanation,
        personnelId: (item.personnel && this.editedItem.category.personnelRelated)? item.personnel.id : null,
        bonusTypes : item.bonusTypes ? Array.from(item.bonusTypes,x => x.id) : null
      })
      .then(response => {
        if (response.status === 200) {
          this.getIncomesByInterval(this.incomesStartDate,this.incomesEndDate);
          this.$radio.$emit('success', {message:'Income Updated Successfully'});
          this.close();
        }         
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    deleteIncome(item){
      this.$axios.delete(this.$apiurl + API_URL+'/'+item.id)
      .then(response => {
        if (response.status === 200) {
          const index = this.incomes.indexOf(item)
          this.incomes.splice(index, 1);
          this.$radio.$emit('success', {message:'Income Deleted Successfully'});
        }
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    bankAccountSelected(item){      
      this.editedItem.currency = item.currency;
    },      
    getIncomesByInterval(startDate, endDate){
      this.$axios.get(this.$apiurl + API_URL, { 
            params: {
              startDate: startDate,
              endDate: endDate,
            }                                               
          })
          .then(response => {
            this.totalIncomeAmount = response.data.totalAmount;
            this.totalIncomeAmountUSD = response.data.totalAmountUSD;
            this.incomes = response.data.incomeList;
            this.showProgress = false;
          }) 
          .catch(error => {
              console.log(error);
          });  
    },
    getIncomesByIntervalAndBonusType(startDate, endDate,selectedFilters){
      this.$axios.post(this.$apiurl + API_URL+"/filter/bonusTypes", {             
            startDate: startDate,
            endDate: endDate,
            bonusTypes : selectedFilters                 
          })
          .then(response => {
            this.totalIncomeAmount = response.data.totalAmount;
            this.totalIncomeAmountUSD = response.data.totalAmountUSD;
            this.incomes = response.data.incomeList;
            this.showProgress = false;
          }) 
          .catch(error => {
              console.log(error);
          });  
    },
    getMasterCategories(){     
      this.$axios.get(this.$apiurl + MASTER_CATEGORIES_API_URL)
          .then(response => {
              this.masterCategoryList = response.data
          }) 
          .catch(error => {
              console.log(error);
          });                         
    },
    getCategoriesByMaster(master){         
        this.$axios.get(this.$apiurl + CATEGORIES_API_URL+'/'+master)
            .then(response => {
                this.categoryList = response.data
                this.editedItem.category = this.categoryList[0];  
            })
            .catch(error => {
                console.log(error);
            });                         
    },
    getCategories(){     
        this.$axios.get(this.$apiurl + CATEGORIES_API_URL)
            .then(response => {
                this.categoryList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },    
    getSalesByInterval(startDate, endDate){
      this.$axios.get(this.$apiurl + SALES_API_URL, { 
            params: {
              startDate: startDate,
              endDate: endDate,
              showUnpaid: true
            }                                               
          })
          .then(response => {
              this.saleList = response.data.saleList
          }) 
          .catch(error => {
              console.log(error);
          });  
    },
    getBonusTypes(){     
        this.$axios.get(this.$apiurl + BONUS_TYPES_API_URL)
            .then(response => {
                this.bonusTypeList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getCurrencies(){     
        this.$axios.get(this.$apiurl + CURRENCIES_API_URL)
            .then(response => {
                this.currencyList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getBankAccounts(){     
        this.$axios.get(this.$apiurl + BANK_ACCOUNTS_API_URL)
            .then(response => {
                this.bankAccountList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getPersonnels(){     
      this.$axios.get(this.$apiurl + PERSONNEL_API_URL)
          .then(response => {
              this.personnels = response.data
          }) 
          .catch(error => {
              console.log(error);
          });                         
    },
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
